var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollBox",staticClass:"test_02"},[_c('div',{ref:"scrollArea",staticClass:"test_01"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }